import { AccordionController } from "./comp-accordion"

/**
 * FAQアコーディオンの初期化
 *
 * @description 共通のAccordionControllerを使う。
 *              排他モードにはしない（デザイン上、複数同時に開いた状態がある）。
 */
export const faqAccordion = new AccordionController(".faq")
